export enum MarkerTypeName {
  CURRENT = 'current',
  BLANK = 'blank',
  NEW_BLANK = 'blank-ally',
  FAVORITE = 'favorite',
  DRAG_START = 'drag-start',
  LOADING = 'loading',
  STORE = 'store',
  USER = 'user',
  MESSENGER = 'ally',
  NEW_MESSENGER = 'new-ally',
  ROUND_TRIP = 'round-trip',
  TRUCK = 'truck'
}
